import { Box, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { JobRequestOrigination } from "gen/clients";
import { NavMenuOption, PageLayout } from "components/PageLayout/PageLayout";
import Divider from "@mui/material/Divider";
import { useParams, useHistory } from "react-router-dom";
import { PagePath } from "types/PagePath";
import { JobRequestList } from "../components/JobRequestList/JobRequestList";

export enum MtTabId {
  documentTranslation = "documentTranslation",
  mediaTranslation = "mediaTranslation",
  aiToolbox = "aiToolbox"
}

const MTJobRequestsPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<string>(MtTabId.documentTranslation);
  const { tabId } = useParams<{ tabId: string }>();
  const history = useHistory();

  React.useEffect(() => {
    if (tabId && Object.values(MtTabId).includes(tabId as MtTabId)) {
      setSelectedTab(tabId as MtTabId);
    } else {
      // Redirect to default tab if the tabId is invalid
      history.push(`${PagePath.mtJobRequests}/${MtTabId.documentTranslation}`);
    }
  }, [tabId, history]);

  // Update the handleTabChange function to update the URL
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setSelectedTab(newValue);
    history.push(`${PagePath.mtJobRequests}/${newValue}`);
  };

  return (
    <PageLayout
      selectedNavMenu={NavMenuOption.MT_JOB_REQUESTS}
      title={
        <Toolbar disableGutters={true} variant="dense">
          <Box flexGrow={1}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Machine Translation Job Requests
            </Typography>
          </Box>
        </Toolbar>
      }
    >
      <Tabs value={selectedTab} onChange={handleTabChange} aria-label="Translation Tabs">
        <Tab
          value={MtTabId.documentTranslation}
          label={<Typography fontWeight="bold">Document Translations</Typography>}
        />
        <Tab value={MtTabId.mediaTranslation} label={<Typography fontWeight="bold">Media Translations</Typography>} />
        <Tab value={MtTabId.aiToolbox} label={<Typography fontWeight="bold">AI Toolbox</Typography>} />
      </Tabs>
      <Divider />
      <Box px={1} my={1}>
        {selectedTab === MtTabId.documentTranslation && (
          <JobRequestList
            origination={JobRequestOrigination.MT}
            getDetailsPagePath={jobRequestId =>
              `${PagePath.mtJobRequests}/${MtTabId.documentTranslation}/${jobRequestId}`
            }
          />
        )}
        {selectedTab === MtTabId.mediaTranslation && (
          <JobRequestList
            origination={JobRequestOrigination.MEDIAAI}
            getDetailsPagePath={jobRequestId => `${PagePath.mtJobRequests}/${MtTabId.mediaTranslation}/${jobRequestId}`}
          />
        )}
        {selectedTab === MtTabId.aiToolbox && (
          <JobRequestList
            origination={JobRequestOrigination.AITBX}
            getDetailsPagePath={jobRequestId => `${PagePath.mtJobRequests}/${MtTabId.aiToolbox}/${jobRequestId}`}
          />
        )}
      </Box>
    </PageLayout>
  );
};

export { MTJobRequestsPage };
